import { Title } from "./Title";

export function HeaderSimulacao() {
  return <Title children="Simulação de custo por Produto" />;
}
